export default "__VITE_ASSET__wu$ttiNP__"